const seo = data => {
  const defaultTitle = "CultureHQ.com";
  const title = data.title || defaultTitle;

  document.title = title;
};

export default seo;
